import { TranslationDict } from "../types";

export const enCommon: TranslationDict = {
  areYouSure: "Are you sure?",
  cancel: "Cancel",
  datum: "Date",
  deleteProject: "Delete project",
  error: "Error",
  filter: "Filter...",
  naam: "Name",
  noProjectsFound: "No projects found",
  ok: "OK",
  openProject: "Open project",
  projectDeleteConfirm: "This project will be permanently deleted.",
  projects: "Projects",
  projectName: "Project name",
  save: "Save",
  saveProject: "Save project",
  sortByDate: "Sort by date",
  voornaam: "First name",
  firma: "Company",
  straat: "Street",
  huisnummer: "House number",
  postcode: "Postal code",
  plaats: "City",
  land: "Country",
  telefoon: "Phone",
  btwnr: "VAT number",
  verwijderen: "Delete",
  hernoem: "Rename",
  dupliceren: "Duplicate",
  wijzigIcon: "Change icon",
  wijzigNaam: "Change name",
  wit: "White",
  zwart: "Black",
};
